import { ClerkProvider } from "@clerk/clerk-react"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App.tsx"
import "./index.css"

// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

const clerkAppearance = {
  elements: {
    userButtonAvatarBox: "w-12 h-12", // Adjust width and height as needed
  },
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      afterSignOutUrl="/"
      appearance={clerkAppearance}
    >
      <App />
    </ClerkProvider>
  </StrictMode>
)
